// import BASE_API from '@/api/dataBase';
// 06-材质，04-规格，05-包装
export const producerColumns = (ctx) => {
  return [
    {
      prop: 'companyCode',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'departmentCode',
      name: '部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'name',
      name: '名称',
      type: 'input',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'pinyin',
      name: '拼音',
      type: 'input',
    },
    {
      prop: 'productCategoryCode',
      name: '商品分类',
      type: 'select',
      // apiUrl: BASE_API.GET_PRODUCT_CAT_TREE,
      options: ctx.productCategoryList,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'attrStatus',
      name: '状态',
      type: 'select',
      options: attrStatusOptions,
    },
    // 只有包装有
    {
      prop: 'unit',
      name: '单位',
      type: 'input',
      isHidden: ctx.attrType != '05',
    },
    {
      prop: 'unitMass',
      name: '单位重量',
      type: 'input',
      isHidden: ctx.attrType != '05',
    },
    {
      prop: 'packingGroup',
      name: '包装类别',
      type: 'input',
      isHidden: ctx.attrType != '05',
    },
    // 只有规格有
    {
      prop: 'goodsClassifyCode',
      name: '货物分类',
      type: 'select',
      options: ctx.goodsClassifyList,
      isHidden: ctx.attrType != '04',
    },
    {
      prop: 'productId',
      name: '商品名称',
      type: 'select',
      options: ctx.goodsTypeList,
      isHidden: !['04', '06'].includes(ctx.attrType),
    },
    {
      prop: 'modelCode',
      name: '编号',
      type: 'input',
      isHidden: ctx.attrType != '04',
    },
    {
      prop: 'modelLong',
      name: '长',
      type: 'input',
      isHidden: ctx.attrType != '04',
    },
    {
      prop: 'modelWide',
      name: '宽',
      type: 'input',
      isHidden: ctx.attrType != '04',
    },
    {
      prop: 'modelThick',
      name: '厚',
      type: 'input',
      isHidden: ctx.attrType != '04',
    },
    {
      prop: 'modelCalculateWeight',
      name: '理计重量',
      type: 'input',
      isHidden: ctx.attrType != '04',
    },
    {
      prop: 'isModelCalculate',
      name: '是否理计',
      type: 'select',
      options: [
        { value: '0', label: '否' },
        { value: '1', label: '是' },
      ],
      isHidden: ctx.attrType != '04',
    },
  ];
};

export const attrStatusOptions = [
  { value: '1', label: '启用' },
  { value: '2', label: '禁用' },
];
